import {
	reSubthemesOgulConstants
}from './constants'
import api from './api'
import {
	defAction
}from "../../../helpers/defaultAction"
export const reSubthemesOgulActions = {
	clear,
	clearCount,
	clearCreateReOrgReSubthemeOguls,
	createReOrgReSubthemeOguls,
	createSubthemeOgul,
	deleteSubthemeOgul,
	getByTheme,
	getCountByTheme,
	getReOrgReSubthemeOgulsList,
	getSubthemeByName,
	removeReOrgReSubthemeOguls,
	restoreSubthemeOgul,
	updateSubthemeOgul

}

function getByTheme(params){
	return dispatch => {
		dispatch(request())
		api.getByTheme(params).then(res => {
			dispatch(success(res))
		})
			.catch(e => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reSubthemesOgulConstants.SEND_RESUBTHEMESOGUL_REQUEST
			}
		}
		function success(subThemeOgul){
			return {
				type    : reSubthemesOgulConstants.SEND_RESUBTHEMESOGUL_SUCCESS,
				payload : subThemeOgul
			}
		}
		function failure(error){
			return {
				type    : reSubthemesOgulConstants.SEND_RESUBTHEMESOGUL_FAILURE,
				payload : error
			}
		}
	}
}

function getSubthemeByName(params){
	return dispatch => {
		dispatch(request())

		api.getSubthemeByName(params).then(res => {
			dispatch(success(res))
		})
			.catch(e => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reSubthemesOgulConstants.SEND_RESUBTHEMESOGUL_REQUEST
			}
		}
		function success(subThemeOgul){
			return {
				type    : reSubthemesOgulConstants.SEND_RESUBTHEMESOGUL_SUCCESS,
				payload : subThemeOgul
			}
		}
		function failure(error){
			return {
				type    : reSubthemesOgulConstants.SEND_RESUBTHEMESOGUL_FAILURE,
				payload : error
			}
		}
	}
}
function createSubthemeOgul(values){
	const dispatchObj = {
		constants : reSubthemesOgulConstants.CreateReSubthemeOguls,
		service   : {
			func   : api.createSubthemeOgul,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function deleteSubthemeOgul(values){
	const dispatchObj = {
		constants : reSubthemesOgulConstants.DeleteReSubthemeOguls,
		service   : {
			func   : api.deleteSubthemeOgul,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restoreSubthemeOgul(values){
	const dispatchObj = {
		constants : reSubthemesOgulConstants.RestoreReSubthemeOguls,
		service   : {
			func   : api.restoreSubthemeOgul,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function updateSubthemeOgul(values){
	const dispatchObj = {
		constants : reSubthemesOgulConstants.UpdateReSubthemeOguls,
		service   : {
			func   : api.updateSubthemeOgul,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getCountByTheme(params){
	const dispatchObj = {
		constants : reSubthemesOgulConstants.GetSubThemesCountByTheme,
		service   : {
			func   : api.getSubThemesCountByTheme,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function clearCount(){
	return (dispatch) => dispatch({
		type: reSubthemesOgulConstants.GetSubThemesCountByTheme.CLEAR
	})
}

function clear(){
	return (dispatch) => dispatch({
		type: reSubthemesOgulConstants.CLEAR_RESUBTHEMESOGUL
	})
}

function getReOrgReSubthemeOgulsList(params){
	const dispatchObj = {
		constants : reSubthemesOgulConstants.GetReOrgReSubthemeOgulsList,
		service   : {
			func   : api.getReOrgReSubthemeOgulsList,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function createReOrgReSubthemeOguls(params){
	const dispatchObj = {
		constants : reSubthemesOgulConstants.CreateReOrgReSubthemeOguls,
		service   : {
			func   : api.createReOrgReSubthemeOguls,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function clearCreateReOrgReSubthemeOguls(){
	return (dispatch) => dispatch({
		type: reSubthemesOgulConstants.CreateReOrgReSubthemeOguls.CLEAR
	})
}

function removeReOrgReSubthemeOguls(params){
	const dispatchObj = {
		constants : reSubthemesOgulConstants.RemoveReOrgReSubthemeOguls,
		service   : {
			func   : api.removeReOrgReSubthemeOguls,
			params : params
		}
	}

	return defAction(dispatchObj)
}

/*
 * function getAppealByName(params) {
 *   return dispatch => {
 *     dispatch(request())
 */

/*
 *     api.getAppealByName(params).then(res => {
 *       dispatch(success(res))
 *     }).catch(e => {
 *       dispatch(failure(e))
 *     })
 */

/*
 *     function request() { return {
 *       type: reAppealTypesConstants.SEND_REAPPEALTYPES_REQUEST
 *     } }
 *     function success(appealTypes) { return {
 *       type: reAppealTypesConstants.SEND_REAPPEALTYPES_SUCCESS,
 *       payload: appealTypes
 *     } }
 *     function failure(error) { return {
 *       type: reAppealTypesConstants.SEND_REAPPEALTYPES_FAILURE,
 *       payload: error
 *     } }
 *   }
 * }
 */